import type { RootStateOr } from 'cadenza/store/cadenza-store';
import {
  getReports,
  hasForceMaximizedView,
  isWorkbookChanged,
  isWorkbookSaved,
  isWorkbookWritable,
} from 'cadenza/workbook/workbook-core-selectors.state';
import { isWorkbookFeatureAvailable } from 'cadenza/workbook/workbook-features';
import type { WorkbookState } from 'cadenza/workbook/workbook.state';

export function isShareButtonDisabled(state: RootStateOr<WorkbookState>) {
  return !isWorkbookSaved(state) || hasForceMaximizedView(state);
}

export function isDownloadWorkbookMenuItemVisible(state: RootStateOr<WorkbookState>) {
  return isWorkbookFeatureAvailable(state, 'workbook-zip-export') && !isWorkbookChanged(state);
}

export function isGenerateReportsWorkbookMenuItemVisible(state: RootStateOr<WorkbookState>) {
  return (
    isWorkbookFeatureAvailable(state, 'workbook-pdf-export') && (getReports(state).length || isWorkbookWritable(state))
  );
}
